module.exports = __webpack_public_path__ + "img/ahoo-update-icon.a808f40d.png";